import { startsWith } from 'lodash';

const readEnvVariable = (key: keyof typeof window.__env) =>
  process.env[key] || window.__env?.[key];

const readEnvVariableWithOrigin = (key: keyof typeof window.__env) => {
  const value = readEnvVariable(key);
  if (!value) {
    return '';
  }
  if (startsWith(value, 'http')) {
    return value;
  }

  return `${window.location.origin}${value}`;
};

export const env = {
  apiUrl: readEnvVariableWithOrigin('REACT_APP_API_HOST'),
  dataApiUrl: readEnvVariableWithOrigin('REACT_APP_DATA_API_URL'),
  publicApiUrl: readEnvVariableWithOrigin('REACT_APP_PUBLIC_API_URL'),
  sciHost: readEnvVariableWithOrigin('REACT_APP_SCI_HOST'),
};
